/**
 * Handles importing of 3D Editor elements into the Blueprint editor.
 */
import { BlueprintEditorTool, BlueprintEditorTools } from '../../definitions'
import useEditor from './hooks/useEditor'
import useElementsPanel from './hooks/useElementsPanel'
import useMainCanvas from './hooks/useMainCanvas'

const Editor3DElements: BlueprintEditorTool = {
  key: BlueprintEditorTools.Editor3DElements,
  authCheck: () => true, // No specific auth check for this tool
  hooks: {
    useEditor,
    useMainCanvas,
    useElementsPanel,
  },
}

export default Editor3DElements
